import React, { Component, Fragment } from "react";

class BlintzboxHoc extends Component {
  render() {
    return <Fragment></Fragment>;
  }
}

export default BlintzboxHoc;
